import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Profile from "./UserProfile";
import Manager from "./Manager";
import Technician from "./Technician";
import DefaultPage from "../App/DefaultFolder";
import { CheckLocalStorage } from "../../Api/Utils/ReuseableFunctions";

const routing = props => (
  <Switch>
    <Route exact path={`${props.match.path}/profile`} component={Profile} />
    <Route
      path={`${props.match.path}/manager`}
      render={() =>
        props.emplRole === "Workshop Admin" &&
        CheckLocalStorage(props.match) ? (
          <Manager />
        ) : props.emplRole === "Workshop Manager" &&
          CheckLocalStorage(props.match) ? (
          <Manager />
        ) : props.user.isDelegated &&
          props.user.isDelegated === "Y" &&
          CheckLocalStorage(props.match) ? (
          <Manager />
        ) : (
          <Redirect to="/notfound" />
        )
      }
    />
    <Route
      path={`${props.match.path}/technician`}
      render={() =>
        CheckLocalStorage(props.match) ? (
          <Technician />
        ) : (
          <Redirect to="/notfound" />
        )
      }
    />
    <Route path={`${props.match.path}/home`} component={DefaultPage} />
  </Switch>
);
export default routing;
